
export enum ChainId {
  TESTNET = 9000,
  MAINNET = 9001
}

export interface Address {
  [ChainId.TESTNET]?: string
  [ChainId.MAINNET]: string
}

export enum ConnectorNames {
  Injected = "injected",
}